// chatModeBus — tiny pub/sub so the global Navbar can show a "you are
// here" badge that mirrors the current chat shell mode (Chat / Image /
// Research / Analyze / Builder / Library) when the user is on the home
// route. The Navbar can't read UnifiedChatShell's local state directly
// without coupling them through a context provider — and a context
// would force a re-render at the App root every time the mode flips,
// which is overkill. A tiny store + subscribe gives us a one-way push
// from the chat shell → Navbar with zero ceremony.
//
// Convention: only the chat shell calls `setChatMode`. It clears the
// value on unmount so the badge falls back to the route-derived label
// when the user navigates away.
export type ChatModeId =
  | "chat"
  | "image"
  | "research"
  | "analyze"
  | "builder"
  | "library";

const listeners = new Set<(mode: ChatModeId | null) => void>();
let current: ChatModeId | null = null;

export const setChatMode = (mode: ChatModeId | null) => {
  if (current === mode) return;
  current = mode;
  for (const l of listeners) l(mode);
};

export const getChatMode = (): ChatModeId | null => current;

export const subscribeChatMode = (
  listener: (mode: ChatModeId | null) => void,
): (() => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
